<aside
  class="
    d-flex
    flex-column
    align-items-stretch
    h-100
    bg-body-secondary
    text-body
    shadow-sm
    overflow-y-auto
  ">
  <div
    class="
      d-flex
      align-items-center
      justify-content-center
      flex-shrink-0
      px-3
      pt-5
      pt-lg-6
    ">

    <a
      href="https://onesecondexchange.com/"
      target="_blank"
      rel="noopener noreferrer"
      class="
        d-inline-flex
        align-items-center
        justify-content-center
        text-decoration-none
      "
      aria-label="One Second Exchange">

      <span
        class="
          d-inline-flex
          align-items-center
          justify-content-center
          rounded-3
          p-2
        ">

        @if (themeMode$ | async; as mode) {
          <img
            [src]="'/assets/images/logo/logo-sign-' + mode + '-vertical.webp'"
            alt="One Second Exchange"
            class="d-block object-fit-contain"
            width="150"
            height="70">
        }
      </span>
    </a>
  </div>
  <nav
    class="
      flex-grow-1
      px-3
      pt-4
      pb-5
      mt-3
    "
    aria-label="Main navigation">

    <ul
      class="
        nav
        flex-column
        flex-nowrap
        gap-2
        list-unstyled
        m-0
        p-0
      ">
      <li class="nav-item">
        <a
          class="
            nav-link
            d-flex
            flex-column
            align-items-center
            justify-content-center
            gap-2
            w-100
            rounded-3
            text-center
            text-body
            fw-normal
            opacity-75
            px-2
            py-3
          "
          [routerLink]="['/dashboard']"
          [routerLinkActive]="activeLinkClasses"
          [routerLinkActiveOptions]="{ exact: true }"
          ariaCurrentWhenActive="page"
          (click)="onLinkClick()">

          <i
            class="icon-dashboard fs-1 lh-1"
            aria-hidden="true">
          </i>

          <span class="small">
            {{ 'SIDEBAR.Dashboard' | translate }}
          </span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="
            nav-link
            d-flex
            flex-column
            align-items-center
            justify-content-center
            gap-2
            w-100
            rounded-3
            text-center
            text-body
            fw-normal
            opacity-75
            px-2
            py-3
          "
          [routerLink]="['/wallets']"
          [routerLinkActive]="activeLinkClasses"
          [routerLinkActiveOptions]="{ exact: false }"
          ariaCurrentWhenActive="page"
          (click)="onLinkClick()">

          <i
            class="icon-wallet fs-1 lh-1"
            aria-hidden="true">
          </i>

          <span class="small">
            {{ 'SIDEBAR.MyAssets' | translate }}
          </span>
        </a>
      </li>

      <!-- Transactions -->
      <li class="nav-item">
        <a
          class="
            nav-link
            d-flex
            flex-column
            align-items-center
            justify-content-center
            gap-2
            w-100
            rounded-3
            text-center
            text-body
            fw-normal
            opacity-75
            px-2
            py-3
          "
          [routerLink]="['/transactions']"
          [routerLinkActive]="activeLinkClasses"
          [routerLinkActiveOptions]="{ exact: false }"
          ariaCurrentWhenActive="page"
          (click)="onLinkClick()">

          <i
            class="icon-chart fs-1 lh-1"
            aria-hidden="true">
          </i>

          <span class="small">
            {{ 'SIDEBAR.Transactions' | translate }}
          </span>
        </a>
      </li>

      <!-- Remittances -->
      <li class="nav-item">
        <a
          class="
            nav-link
            d-flex
            flex-column
            align-items-center
            justify-content-center
            gap-2
            w-100
            rounded-3
            text-center
            text-body
            fw-normal
            opacity-75
            px-2
            py-3
          "
          [routerLink]="['/remittances']"
          [routerLinkActive]="activeLinkClasses"
          [routerLinkActiveOptions]="{ exact: false }"
          ariaCurrentWhenActive="page"
          (click)="onLinkClick()">

          <i
            class="icon-bill fs-1 lh-1"
            aria-hidden="true">
          </i>

          <span class="small">
            {{ 'SIDEBAR.Remittances' | translate }}
          </span>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="
            nav-link
            d-flex
            flex-column
            align-items-center
            justify-content-center
            gap-2
            w-100
            rounded-3
            text-center
            text-body
            fw-normal
            opacity-75
            px-2
            py-3
          "
          [routerLink]="['/bank-accounts']"
          [routerLinkActive]="activeLinkClasses"
          [routerLinkActiveOptions]="{ exact: false }"
          ariaCurrentWhenActive="page"
          (click)="onLinkClick()">

          <i
            class="icon-accounts fs-1 lh-1"
            aria-hidden="true">
          </i>

          <span class="small">
            {{ 'SIDEBAR.BankAccounts' | translate }}
          </span>
        </a>
      </li>
      @if (!hasCards()) {
        <li class="nav-item">
          <a
            class="
              nav-link
              d-flex
              flex-column
              align-items-center
              justify-content-center
              gap-2
              w-100
              rounded-3
              text-center
              text-body
              fw-normal
              opacity-75
              px-2
              py-3
            "
            [routerLink]="['/identification']"
            [routerLinkActive]="activeLinkClasses"
            [routerLinkActiveOptions]="{ exact: false }"
            ariaCurrentWhenActive="page"
            (click)="onLinkClick()">

            <i
              class="icon-authentication fs-1 lh-1"
              aria-hidden="true">
            </i>

            <span class="small">
              {{ 'SIDEBAR.Identification' | translate }}
            </span>
          </a>
        </li>
      }
      <li
        class="
          nav-item
          d-lg-none
          d-flex
          flex-column
          align-items-center
          justify-content-center
          gap-3
          mx-auto
          mt-4
        ">

        <lib-language-switch
          class="d-block">
        </lib-language-switch>

        <lib-theme-mode-switch
          class="
            d-flex
            align-items-center
            justify-content-center
          ">
        </lib-theme-mode-switch>
      </li>

    </ul>
  </nav>
</aside>
